<!-- has to be changed if we want to use it for contacts, too - this is for addressContactLinks -->
<ng-template #dpBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? ('crm.save-contact-first' | translate)
                : ('crm.missing-data-for-save' | translate)
        "
        [loading]="isSaving"
        icon="fa fa-save"
        [label]="'crm.save-contact-first' | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>
<blockable-div #dpBlock [blocked]="!model?.contact?.id" [blockUi]="dpBlockUi">
    @if (model?.contact?.id) {
        <app-data-protection-widget [contactIdSig]="this.model.contact.id" />
    }
</blockable-div>
